import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateControl } from '@api/controls';
import { Card, message, Button } from 'antd';
import { ButtonContainer } from './styled';
import { NEXA_LEGAL_ACCEPTANCE_KEY } from '@src/utils/constants/controls';
import { logger } from '@src/utils/misc/logger';
import VideoBanner from './VideoBanner';

const AdminAcceptanceBanner = ({ can_enable = false }) => {
  const queryClient = useQueryClient();

  const enableNexaMutation = useMutation({
    mutationFn: () =>
      updateControl(NEXA_LEGAL_ACCEPTANCE_KEY, {
        status: true,
        value: null,
        reason: 'Admin enabled Nexa access',
      }),
    onSuccess: () => {
      // Invalidate and refetch controls init query
      queryClient.invalidateQueries(['controls-init']);
      message.success('Nexa has been enabled successfully!');
    },
    onError: (error: any) => {
      logger.log('Failed to enable Nexa:', error);
      message.error('Failed to enable Nexa. Please try again.');
    },
  });

  const handleEnableNexa = () => {
    enableNexaMutation.mutate();
  };

  return (
    <Card style={{ fontSize: '16px' }}>
      <div style={{ display: 'flex', gap: '20px', minHeight: '30vh', minWidth: '80vw' }}>
        <div style={{ flex: 1 }}>
          <h3>Welcome to the Nexa</h3>
          <p style={{ marginBottom: '20px', marginTop: '-5px', fontWeight: 'bold' }}>
            Ask simple, natural-language questions to uncover actionable insights and identify
            anomalies.
          </p>

          <p>
            Want to start your free trial of Nexa, Conviva&apos;s AI-powered analytics assistant?
          </p>

          {can_enable ? (
            <div>
              <p>
                Click <strong>Enable</strong> to begin your trial. By doing so, you confirm that
                your organization accepts and agrees to{' '}
                <a
                  href="https://www.conviva.com/ai-acceptable-use-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Conviva&apos;s Tools Acceptance Policy
                </a>
                .
              </p>
              <p style={{ color: '#888', fontSize: '14px' }}>
                Note: As your company&apos;s account admin, once you enable Nexa, it will be enabled
                for all users within your account. You can always disable it later from your
                Settings.
              </p>
            </div>
          ) : (
            <div>
              <p>Please contact your admin to enable Nexa.</p>
            </div>
          )}
        </div>
        <VideoBanner />
      </div>
      <div>
        {can_enable && (
          <ButtonContainer>
            <Button
              disabled={enableNexaMutation.isLoading}
              onClick={handleEnableNexa}
              type="primary"
            >
              {enableNexaMutation.isLoading ? 'Enabling...' : 'Enable Nexa for My Team'}
            </Button>
          </ButtonContainer>
        )}
      </div>
    </Card>
  );
};

export default AdminAcceptanceBanner;
